<template>
  <div id="tab_performance" class="tab-pane fade in active">
    <div class="tab__header">Performance Evaluation</div>
    <Comparisons></Comparisons>
    <div class="kpi__table-container kpi__table-container--bordered">
      <table class="kpi-performance-table">
        <TableHead title="A. FINANCIAL PERFORMANCE" :month-year-string="monthYearString"></TableHead>
        <TableSubHead></TableSubHead>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metricsFinancialPerformance" :key="`financial-${metric.field}-${index}`" :metric="metric"></component>

        <TableHead title="B. OPERATIONAL PERFORMANCE" :month-year-string="monthYearString"></TableHead>
        <TableSubHead></TableSubHead>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metricsOperationalPerformance" :key="`operational-${index}`" :metric="metric"></component>

        <TableHead title="C. PERSONNEL PERFORMANCE" :month-year-string="monthYearString"></TableHead>
        <TableSubHead></TableSubHead>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metricsPersonnelPerformance" :key="`personnel-${index}`" :metric="metric"></component>
      </table>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import TableHead from './performance-evaluation/TableHead.vue';
  import TableSubHead from './performance-evaluation/TableSubHead.vue';
  import TableRowBase from './performance-evaluation/table-rows/TableRowBase.vue';
  import TableRowGrossHaRevPerGrossRev from './performance-evaluation/table-rows/TableRowGrossHaRevPerGrossRev.vue';
  import TableRowGrossMarginPerNetHaRev from './performance-evaluation/table-rows/TableRowGrossMarginPerNetHaRev.vue';
  import TableRowNetProfitPerNetHaRev from './performance-evaluation/table-rows/TableRowNetProfitPerNetHaRev.vue';
  import TableRowMarketingSpendPer from './performance-evaluation/table-rows/TableRowMarketingSpendPer.vue';
  import TableRowPayrollRelatedPerNetRev from './performance-evaluation/table-rows/TableRowPayrollRelatedPerNetRev.vue';
  import TableRowAvgDollarsDiscounted from './performance-evaluation/table-rows/TableRowAvgDollarsDiscounted.vue';
  import TableRowHaeConversionRate from './performance-evaluation/table-rows/TableRowHaeConversionRate.vue';
  import TableRowHaeToAudiogramRate from './performance-evaluation/table-rows/TableRowHaeToAudiogramRate.vue';
  import TableRowBinauralRate from './performance-evaluation/table-rows/TableRowBinauralRate.vue';
  import TableRowAvgSellingPricePreDisc from './performance-evaluation/table-rows/TableRowAvgSellingPricePreDisc.vue';
  import TableRowDiscountPer from './performance-evaluation/table-rows/TableRowDiscountPer.vue';
  import TableRowAvgSellingPricePostDisc from './performance-evaluation/table-rows/TableRowAvgSellingPricePostDisc.vue';
  import TableRowAvgPatientNetRev from './performance-evaluation/table-rows/TableRowAvgPatientNetRev.vue';
  import TableRowDollarRefundRate from './performance-evaluation/table-rows/TableRowDollarRefundRate.vue';
  import TableRowUnitRefundRate from './performance-evaluation/table-rows/TableRowUnitRefundRate.vue';
  import TableRowMarginPerUnit from './performance-evaluation/table-rows/TableRowMarginPerUnit.vue';
  import TableRowNetRevPerProvider from './performance-evaluation/table-rows/TableRowNetRevPerProvider.vue';
  import TableRowNetRevPerPhysician from './performance-evaluation/table-rows/TableRowNetRevPerPhysician.vue';
  import Comparisons from './Comparisons.vue';

  export default {
    name: 'Performance',
    components: {
      Comparisons,
      TableHead,
      TableSubHead,
      TableRowBase,
      TableRowGrossHaRevPerGrossRev,
      TableRowGrossMarginPerNetHaRev,
      TableRowNetProfitPerNetHaRev,
      TableRowMarketingSpendPer,
      TableRowPayrollRelatedPerNetRev,
      TableRowAvgDollarsDiscounted,
      TableRowHaeConversionRate,
      TableRowHaeToAudiogramRate,
      TableRowBinauralRate,
      TableRowAvgSellingPricePreDisc,
      TableRowDiscountPer,
      TableRowAvgSellingPricePostDisc,
      TableRowAvgPatientNetRev,
      TableRowDollarRefundRate,
      TableRowUnitRefundRate,
      TableRowMarginPerUnit,
      TableRowNetRevPerProvider,
      TableRowNetRevPerPhysician,
    },
    data() {
      return {
        compMode: 'number',
        pugTemplateName: 'PerformanceEvaluationTableRow.pug',
      };
    },
    computed: {
      ...mapGetters('audiologyKpis', [
        'metricsFinancialPerformance',
        'metricsOperationalPerformance',
        'metricsPersonnelPerformance',
        'ytdCustomCalculationFields',
        'monthsInReport',
        'month',
        'yearStart',
        'year',
      ]),
      currentMonthName() {
        const month = lodash.find(this.monthsInReport, (month) => month.value === this.month);
        return (month) ? month.label : '';
      },
      currentYearName() {
        return (this.month) + this.yearStart > 13 ? parseInt(this.year) + 1 : parseInt(this.year);
      },
      monthYearString() {
        return `- ${this.currentMonthName} ${this.currentYearName}`;
      },
    },
    methods: {
      getComponentName(field) {
        if (this.ytdCustomCalculationFields.includes(field)) {
          return `TableRow${lodash.chain(field).camelCase().upperFirst().value()}`;
        }
        return 'TableRowBase';
      },
    },
  };
</script>
